<template>
    <BreadCrumb PageTitle="Modifier une promotion" />
    <EditPromotion />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import EditPromotion from "../../../components/Ecommerce/Promotion/EditPromotion.vue";
  
    export default defineComponent({
      name: "EditPromotionPage",
      components: {
        BreadCrumb,
        EditPromotion,
      },
    });
  </script>